export const isWorkspaceManagerAvailable = (): boolean =>
  window.__SIRONA_WORKSPACE_MANAGER_AVAILABLE__ === true;

/** Returns the API version, returning `-1` if not found */
export const getWorkspaceManagerVersion = (): number =>
  window.__SIRONA_WORKSPACE_MANAGER_API_VERSION__ ?? -1;
